module.exports = __webpack_public_path__ + "static/media/branding-logo-topbar.bcca6bc3.png";